// src/api/config.js

/**
 * Centralized API configuration
 */
export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_FIXTURES_API_URL || 'https://feed.mossbets.com/mossbets',
  WSS_URL: import.meta.env.VITE_WSS || 'wss://ws.mossbets.com',
  TOKEN: import.meta.env.VITE_TOKEN
}

/**
 * Get authentication headers for API requests
 * @returns {Object} Headers object with Authorization
 */
export const getAuthHeaders = () => {
  return {
    'Authorization': `Bearer ${API_CONFIG.TOKEN}`
  }
}

/**
 * API endpoints
 */
export const API_ENDPOINTS = {
  MARKETS: '/markets/sport_id',
  FIXTURES: '/fixtures/',
  FIXTURES_UPCOMING: '/fixtures/upcoming',
  FIXTURES_LIVE: '/fixtures/live'
}
